export const
    COMPLAINT_CHANGE_COMPLAINT_TYPE= "COMPLAINT_CHANGE_COMPLAINT_TYPE",
    COMPLAINT_CHANGE_TERM_OF_USE_VALUE="COMPLAINT_CHANGE_TERM_OF_USE_VALUE",
    COMPLAINT_GET_COMPLAINT_BY_ID_FAILURE="COMPLAINT_GET_COMPLAINT_BY_ID_FAILURE",
    COMPLAINT_GET_COMPLAINT_BY_ID_REQUEST="COMPLAINT_GET_COMPLAINT_BY_ID_REQUEST",
    COMPLAINT_GET_COMPLAINT_BY_ID_SUCCESS="COMPLAINT_GET_COMPLAINT_BY_ID_SUCCESS",
    COMPLAINT_ISSUE_COMPLAINT_FAILURE="COMPLAINT_ISSUE_COMPLAINT_FAILURE",
    COMPLAINT_ISSUE_COMPLAINT_REQUEST="COMPLAINT_ISSUE_COMPLAINT_REQUEST",
    COMPLAINT_ISSUE_COMPLAINT_SUCCESS="COMPLAINT_ISSUE_COMPLAINT_SUCCESS",
    COMPLAINT_SEARCH_COMPLAINT_FAILURE="COMPLAINT_SEARCH_COMPLAINT_FAILURE",
    COMPLAINT_SEARCH_COMPLAINT_REQUEST="COMPLAINT_SEARCH_COMPLAINT_REQUEST",
    COMPLAINT_SEARCH_COMPLAINT_SUCCESS="COMPLAINT_SEARCH_COMPLAINT_SUCCESS",
    COMPLAINT_NOTES = "COMPLAINT_NOTES";


// WEBPACK FOOTER //
// ./src/types/Complaint.js